import * as yup from "yup";
import { validarTelefone } from "../../core/utils/validarTelefone";

export const usuarioSchema =  yup.object().shape({
  email: yup.string().email("Endereço de e-mail inválido").required("O endereço de e-mail é obrigatório"),
  nome: yup.string().required("O nome é obrigatório"),
  telefone: yup.string().required("O telefone é obrigatório").test('telefone', 'Telefone inválido', (value) => validarTelefone(value, false)),
});
  